import { action } from "satcheljs";

const resetNoteStore = action(
    "RESET_NOTE_STORE",
    () => ({})
);

export default resetNoteStore;